<!-- Property of OSF GLOBAL SERVICES INC. , an OSF Digital company. OSF remains the sole owner of all right, title and interest in the software. Do not copy, sell, reverse engineer or otherwise attempt to derive or obtain information about the functioning, manufacture or operation therein. -->
<style scoped>
.spinner {
    z-index: 10;
}
</style>

<template>
    <div>
        <!-- Small Loader Component, it displays
        inside components  -->
        <div class="veil">
            <div class="underlay">
                <div class="spinner"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Smallloadercomp",
};
</script>
